export const products = [
  {
    id: "jj-hd-001",
    name: "久久插 工业重载插接器 HD-001",
    category: "industrial-connectors",
    slug: "jj-hd-001",
    description: "额定电流 63A，额定电压 500V，采用高强度尼龙外壳与铜合金触点，IP67 防护等级，适用于重型机械和工业自动化场景。",
    price: "¥289.00",
    features: ["IP67 防水防尘", "耐温 -40°C 至 125°C", "5000 次插拔寿命", "抗冲击外壳"],
    imageQuery: "Heavy-duty industrial power connector HD-001, black and orange rugged design, metal contacts visible, workshop background, warm lighting, high contrast product photography",
  },
  {
    id: "jj-hd-002",
    name: "久久插 工业模组插接器 HD-002",
    category: "industrial-connectors",
    slug: "jj-hd-002",
    description: "模组化工业插接器，支持 4/8/12 芯配置，额定电流 16A，嵌入式安装设计，适用于自动化控制柜。",
    price: "¥156.00",
    features: ["模组化设计", "快速接线", "防错插结构", "阻燃 V-0 等级"],
    imageQuery: "Modular industrial rectangular connector with multiple pins, gray and black housing, DIN rail mounting, professional studio lighting, clean white background, technical product style",
  },
  {
    id: "jj-hd-003",
    name: "久久插 大电流圆形插接器 HD-003",
    category: "industrial-connectors",
    slug: "jj-hd-003",
    description: "额定电流 125A 大电流圆形插接器，镀银触点，自锁结构，适用于电源分配与大型设备连接。",
    price: "¥420.00",
    features: ["125A 大电流", "自锁防脱", "镀银触点", "耐电弧设计"],
    imageQuery: "Large circular industrial power connector with silver contacts, metal body with blue trim, industrial power distribution background, dramatic side lighting, professional product shot",
  },
  {
    id: "jj-hh-001",
    name: "久久插 家用安全插座转换器 HH-001",
    category: "household-connectors",
    slug: "jj-hh-001",
    description: "一体式铜条设计，儿童安全保护门，750°C 阻燃外壳，过载自动断电保护，适配多种插头标准。",
    price: "¥39.90",
    features: ["儿童安全门", "过载保护", "750°C 阻燃", "一体铜条"],
    imageQuery: "Modern white household power strip with safety shutters, clean home desk background, soft natural window light, minimalist lifestyle photography, warm cozy atmosphere",
  },
  {
    id: "jj-hh-002",
    name: "久久插 墙面快装插座 HH-002",
    category: "household-connectors",
    slug: "jj-hh-002",
    description: "86 型标准墙面插座，快装卡扣设计，纯平面板，支持 USB-A + USB-C 快充，安全耐用。",
    price: "¥49.90",
    features: ["USB-C 快充", "快装卡扣", "纯平设计", "50000 次按压"],
    imageQuery: "Sleek white wall power outlet with USB-C ports, modern interior wall background, side angle, soft natural lighting, clean product photography, architectural style",
  },
  {
    id: "jj-hh-003",
    name: "久久插 智能插座 HH-003",
    category: "household-connectors",
    slug: "jj-hh-003",
    description: "WiFi 智能插座，APP 远程控制，定时开关，电量统计，语音控制兼容，16A 大功率支持。",
    price: "¥79.90",
    features: ["WiFi 远程控制", "电量统计", "语音控制", "定时开关"],
    imageQuery: "Smart WiFi plug socket, white minimalist design with LED indicator, modern smart home background, warm ambient lighting, tech lifestyle product photography, clean and bright",
  },
  {
    id: "jj-sc-001",
    name: "久久插 施工用防爆插接器 SC-001",
    category: "construction-connectors",
    slug: "jj-sc-001",
    description: "防爆认证插接器，铸铝合金外壳，适用于矿山、化工等高危施工环境，安全可靠。",
    price: "¥680.00",
    features: ["防爆认证", "铸铝外壳", "耐腐蚀", "IP68 防护"],
    imageQuery: "Explosion-proof industrial connector, cast aluminum housing in dark gray, mining site background, dramatic directional lighting, rugged professional product photography",
  },
  {
    id: "jj-sc-002",
    name: "久久插 工地专用配电插接箱 SC-002",
    category: "construction-connectors",
    slug: "jj-sc-002",
    description: "便携式工地配电箱，内置多个插接接口，漏电保护，过载保护，防雨设计。",
    price: "¥1,280.00",
    features: ["漏电保护", "过载保护", "防雨设计", "便携提手"],
    imageQuery: "Portable construction site power distribution box, yellow and black industrial design, outdoor construction site background, bright daylight, rugged product photography",
  },
  {
    id: "jj-pc-001",
    name: "久久插 精密仪器插接组件 PC-001",
    category: "precision-connectors",
    slug: "jj-pc-001",
    description: "高密度微型插接器，0.5mm 间距，镀金触点，适用于医疗设备、精密仪器和数据采集系统。",
    price: "¥580.00",
    features: ["0.5mm 间距", "镀金触点", "低插拔力", "高可靠性"],
    imageQuery: "Miniature precision electronic connector with gold-plated pins on PCB, laboratory clean background, macro photography, soft diffused lighting, high-end technical aesthetic",
  },
  {
    id: "jj-pc-002",
    name: "久久插 高频信号插接器 PC-002",
    category: "precision-connectors",
    slug: "jj-pc-002",
    description: "高频信号插接器，支持最高 40GHz 频率，低驻波比，适用于通信基站和测试测量设备。",
    price: "¥960.00",
    features: ["40GHz 高频", "低驻波比", "精密阻抗匹配", "军工级品质"],
    imageQuery: "High-frequency coaxial RF connector with gold-plated SMA interface, technical laboratory background with test equipment, precise clean lighting, scientific product photography",
  },
  {
    id: "jj-wp-001",
    name: "久久插 户外防水插接器 WP-001",
    category: "waterproof-series",
    slug: "jj-wp-001",
    description: "IP68 级户外防水插接器，全密封结构，采用耐候材料，适用于户外照明、景观喷泉等场景。",
    price: "¥128.00",
    features: ["IP68 防护", "耐候材料", "全密封结构", "UV 抗老化"],
    imageQuery: "Outdoor waterproof electrical connector with blue rubber sealing ring, garden fountain background with water splashes, bright natural light, professional outdoor product photography",
  },
  {
    id: "jj-wp-002",
    name: "久久插 水下专用插接器 WP-002",
    category: "waterproof-series",
    slug: "jj-wp-002",
    description: "深水级插接器，潜水深度可达 50 米，316 不锈钢外壳，适用于水下设备和海洋工程。",
    price: "¥450.00",
    features: ["50 米潜水", "316 不锈钢", "耐海水腐蚀", "双重密封"],
    imageQuery: "Stainless steel underwater connector with dual O-ring seals, underwater blue environment background with bubbles, dramatic lighting through water, professional technical photography",
  },
  {
    id: "jj-wp-003",
    name: "久久插 快接防水插头 WP-003",
    category: "waterproof-series",
    slug: "jj-wp-003",
    description: "快速锁紧防水插头，旋转 90 度即完成连接，IP67 防护，防误插设计，适用于临时户外供电。",
    price: "¥86.00",
    features: ["旋转快锁", "IP67 防护", "防误插", "高柔电缆"],
    imageQuery: "Quick-lock waterproof plug connector, blue and black design, outdoor camping tent background, warm sunset lighting, lifestyle adventure product photography",
  },
  {
    id: "jj-cs-001",
    name: "久久插 定制多芯集束插接器 CS-001",
    category: "custom-solutions",
    slug: "jj-cs-001",
    description: "按需定制的多芯集束插接方案，支持信号、电源、气路混合接入，满足特殊设备需求。",
    price: "联系客服",
    features: ["混合接入", "按需定制", "快速打样", "全程服务"],
    imageQuery: "Custom multi-pin hybrid connector assembly on engineering workbench, technical drawings and 3D models in background, warm desk lamp, professional industrial design photography",
  },
];

export const getProductsByCategory = (categorySlug: string) => {
  return products.filter((p) => p.category === categorySlug);
};

export const getProductBySlug = (slug: string) => {
  return products.find((p) => p.slug === slug);
};